import type { SchemaOrgNode } from '@core-mkt/services/schema/schema-org-node.model';
import { reviewData } from '../review-data';
import { buildReviewListSchema } from '../review-schema.util';

export interface ReviewVariantSchemaData {
  pageUrl: string;
  siteUrl: string;
  organizationName: string;
  /** Optional override of the rendered title — used as ItemList.name if present. */
  reviewTitle?: string;
}

const VARIANT_ID_FRAGMENT = 'reviews-stars';
const DEFAULT_LIST_NAME = 'Customer Testimonials';

/**
 * Returns Review nodes + an ItemList for the star-reviews variant. Reviews are
 * sourced from `reviewData[0]` (hardcoded testimonials).
 */
export function getStarReviewsSchema(data: ReviewVariantSchemaData | null): SchemaOrgNode[] | null {
  if (!data) return null;
  return buildReviewListSchema({
    listId: `${data.pageUrl}#${VARIANT_ID_FRAGMENT}`,
    listName: data.reviewTitle?.trim() || DEFAULT_LIST_NAME,
    siteUrl: data.siteUrl,
    organizationName: data.organizationName,
    items: reviewData[0],
  });
}
